// extracted by mini-css-extract-plugin
module.exports = {"landing-container":"landing-layout_landing-container__cdivl","container":"landing-layout_container__RtXHD"};